import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

// Fetch user data based on userId
export const getAdminData = async (userId) => {
  try {
    let user = null;
    const response = await axiosInstance.get(API.user.getById(userId));
    user = response.data || null;
    return {
      id: user.id,
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      userName: user.userName || user.email || "",
      email: user.email || "",
    };
  } catch (error) {
    console.error("Error fetching user data:", error.response?.data || error.message);
    return null;
  }
};

// Fetch job postings.
// Per Mudassir (2026-05-20): switched from Get-List → Get-All-Postings so the
// Hiring page also returns Filled postings (not just Open ones). The Status
// column + "Mark As Filled" hiding logic on the FE relies on Filled rows
// being present in the response.
export const getJobPostings = async () => {
  try {
    const response = await axiosInstance.get(API.hiringJobPosting.getAllPostings);
    return response.data;
  } catch (error) {
    console.error("Error fetching job postings from API:", error.response?.data || error.message);
    throw error;
  }
};

// Add a new job posting
export const addJobPosting = async (jobData) => {
  try {
    const response = await axiosInstance.post(API.hiringJobPosting.add, jobData);
    return response.data;
  } catch (error) {
    console.error("Error adding job posting:", error.response?.data || error.message);
    throw error;
  }
};

// Update an existing job posting
export const updateJobPosting = async (jobData) => {
  try {
    const response = await axiosInstance.put(API.hiringJobPosting.update, jobData);
    return response.data;
  } catch (error) {
    console.error("Error updating job posting:", error.response?.data || error.message);
    throw error;
  }
};
